var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.showNewUserPage)?_c('CourseNewUser'):_c('CourseUserList')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }